// extracted by mini-css-extract-plugin
export default {"parent":"Contact_parent__1OTFC","contactSpan":"Contact_contactSpan__4H+a3","smallSpan":"Contact_smallSpan__owoqS","contact":"Contact_contact__jCaL2","social":"Contact_social__h60Nj"};